import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { House, Users, Newspaper, ChartBar, SignOut, Shield, ArrowSquareOut, Envelope, ChatCircleDots, CreditCard, ChartLineUp, Megaphone } from "@phosphor-icons/react";
import { clearAuth, getUser } from "../lib/nurseryApi";

const items = [
  { to: "/admin", label: "Overview", icon: ChartBar, end: true, testid: "admin-nav-overview" },
  { to: "/admin/applications", label: "Applications", icon: Envelope, testid: "admin-nav-applications" },
  { to: "/admin/users", label: "Users & Accounts", icon: Users, testid: "admin-nav-users" },
  { to: "/admin/subscriptions", label: "Subscriptions", icon: CreditCard, testid: "admin-nav-subscriptions" },
  { to: "/admin/leads", label: "Leads", icon: ChatCircleDots, testid: "admin-nav-leads" },
  { to: "/admin/finance", label: "Financials", icon: ChartLineUp, testid: "admin-nav-finance" },
  { to: "/admin/marketing", label: "Marketing", icon: Megaphone, testid: "admin-nav-marketing" },
  { to: "/admin/blog", label: "Blog Posts", icon: Newspaper, testid: "admin-nav-blog" },
];

export default function AdminLayout({ children }) {
  const nav = useNavigate();
  const user = getUser();
  const logout = () => { clearAuth(); nav("/login"); };

  return (
    <div className="organic-bg" style={{ minHeight: "100vh" }}>
      <header style={{ background: "var(--text)", color: "var(--bg)", borderBottom: "1px solid rgba(255,255,255,0.1)", position: "sticky", top: 0, zIndex: 30 }}>
        <div style={{ maxWidth: 1400, margin: "0 auto", padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          <a href="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 12, color: "white" }} data-testid="admin-brand">
            <div style={{ width: 38, height: 38, background: "var(--accent)", borderRadius: 12, display: "grid", placeItems: "center" }}>
              <Shield size={20} weight="fill" color="var(--text)" />
            </div>
            <div>
              <div className="font-display" style={{ fontSize: 20, lineHeight: 1, color: "white" }}>NurserySense Admin</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.6)", marginTop: 2 }}>Platform control room</div>
            </div>
          </a>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <NavLink to="/app/dashboard" className="btn btn-ghost" style={{ color: "white" }} data-testid="admin-to-app">
              <House size={16} weight="bold" /> Owner app
            </NavLink>
            <button className="btn btn-ghost" onClick={logout} style={{ color: "white" }} data-testid="admin-logout-btn">
              <SignOut size={16} weight="bold" /> Sign out
            </button>
          </div>
        </div>
      </header>

      <div style={{ maxWidth: 1400, margin: "0 auto", display: "grid", gridTemplateColumns: "240px 1fr" }} className="layout-grid">
        <aside style={{ padding: "24px 16px", minHeight: "calc(100vh - 70px)" }} className="sidebar">
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--muted-fg)", marginBottom: 12, padding: "0 10px" }}>Admin</div>
          <nav style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {items.map(({ to, label, icon: Icon, end, testid }) => (
              <NavLink key={to} to={to} end={end} data-testid={testid}
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
                <Icon size={18} weight="bold" /> {label}
              </NavLink>
            ))}
          </nav>
          <div style={{ marginTop: 28, padding: 16, background: "var(--accent-soft)", borderRadius: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#8B6E1A", letterSpacing: "0.1em", textTransform: "uppercase" }}>Signed in as</div>
            <div style={{ fontSize: 13, marginTop: 6, fontWeight: 700 }}>{user?.email}</div>
            <a href="/blog" target="_blank" rel="noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: "var(--secondary)", marginTop: 10, textDecoration: "underline" }}>
              View public blog <ArrowSquareOut size={12} weight="bold" />
            </a>
          </div>
        </aside>
        <main style={{ padding: "32px 32px 80px" }} className="main-area">{children}</main>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .layout-grid { grid-template-columns: 1fr !important; }
          .sidebar { border-bottom: 1px solid var(--border) !important; min-height: auto !important; padding: 16px !important; }
          .main-area { padding: 24px 16px 60px !important; }
        }
      `}</style>
    </div>
  );
}
